import { Component, ElementRef, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CDSMask } from '@app/utils/cds-mask';

import { TutelaProvisoria, TutelaProvisoriaAdvogado } from '@app/models/util/tutela-provisoria.model';
import { IdDescricao } from '@app/models/util/id-descricao'; 

import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { ConsultasService } from '@app/services/consultas.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { Processo } from '@app/models/processo.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-tutela-provisoria-form',
  templateUrl: './tutela-provisoria-form.component.html'
})
export class TutelaProvisoriaFormComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  @ViewChild('alertaTutelaAberto') alertaTutelaAberto: TemplateRef<any>;
  tutelaProvisoria: TutelaProvisoria = new TutelaProvisoria();
  processo: Processo = new Processo();

  valorEscritorio: number = 0;
  valorEncaminhadoPor: number = 0;
  valorSubstabelecido: number = 0;

  aguardando: boolean = false;
  existeTutelaEmAberto: boolean = false;

  lstAdvogados: IdDescricao[] = [];
  lstErros: string[]= [];

  lstDR_D: IdDescricao[]=[];
  lstDR_R: IdDescricao[]=[];

  constructor(
    private financeiroProcessoService: FinanceiroProcessoService,
    private route: ActivatedRoute,
    private router: Router,
    private consultasService: ConsultasService,
    private _modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.consultasService.consultar('ADVOGADO').toPromise().then(data => this.lstAdvogados = data);
    this.consultasService.consultar('DR_D').toPromise().then(data=> this.lstDR_D =data);
    this.consultasService.consultar('DR_R').toPromise().then(data=> this.lstDR_R =data);

    this.route.parent.params.subscribe(params => {
      const processoId = params['id'];
      this.financeiroProcessoService.obterProcesso(processoId).toPromise().then(processo => {
        this.processo = processo;
        this.tutelaProvisoria.ClienteId = this.processo.ClienteId;
        this.tutelaProvisoria.SubstabelecidoId = this.processo.SubstabelecidoPor;
        this.tutelaProvisoria.EncaminhadoPorId = this.processo.EncaminhadoPor;
        this.tutelaProvisoria.ProcessoId = this.processo.Id;
        
        this.processo.ProcessoAdvogado.forEach(advogado => {
          const adv = new TutelaProvisoriaAdvogado();
          adv.AdvogadoId = advogado.AdvogadoId;
          adv.Desbloqueado = false;
          this.tutelaProvisoria.Advogados.push(adv);
        });
        
        if(this.tutelaProvisoria.Advogados.length === 0){
          this.tutelaProvisoria.Advogados.push(new TutelaProvisoriaAdvogado);
        }
        
        this.tutelaProvisoria.ClienteNome = this.processo.ClienteNome;
        this.tutelaProvisoria.Descricao = this.processo.ClienteNome + ' (' + this.processo.Ficha + ')' +
          ' X ' + this.processo.ParteContraria;

        this.consultasService.consultarTutelaEmAberto(this.processo.Id).toPromise().then(existeTutelaEmAberto => {
          if(existeTutelaEmAberto){
            this._modalService.show(this.alertaTutelaAberto);
          }
        });
      });
      
    })

    this.tutelaProvisoria.VencimentoInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    
    
    
    
  }

  gravarTutela(){
    this.aguardando = true;
    this.financeiroProcessoService.gravarTutela(this.tutelaProvisoria)
    .toPromise().then(
      () => {
        this.router.navigate(['/processos/processo/', this.processo.Id, 'financeiro']);
      },
      (data: any) => {
        if (data.error) { 
        this.lstErros[0]= data.error[0]["Valor"];
        }
        this.aguardando = false;
      });
  }

  sanitizaValores(){
    if (this.tutelaProvisoria.PercentualEscritorio.toString().indexOf(','))
      this.tutelaProvisoria.PercentualEscritorio = Number(this.tutelaProvisoria.PercentualEscritorio.toString().replace(',', '.'));
    if (this.tutelaProvisoria.PercentualSubstabelecido.toString().indexOf(','))
      this.tutelaProvisoria.PercentualSubstabelecido = Number(this.tutelaProvisoria.PercentualSubstabelecido.toString().replace(',', '.'));
    if (this.tutelaProvisoria.PercentualEncaminhadoPor.toString().indexOf(','))
      this.tutelaProvisoria.PercentualEncaminhadoPor = Number(this.tutelaProvisoria.PercentualEncaminhadoPor.toString().replace(',', '.'));
  }

  calculaValores(){
    this.sanitizaValores();
    this.valorEscritorio = this.tutelaProvisoria.ValorMensal * this.tutelaProvisoria.PercentualEscritorio * 0.01;
    this.valorSubstabelecido = this.valorEscritorio * this.tutelaProvisoria.PercentualSubstabelecido * 0.01;
    this.valorEncaminhadoPor = this.valorEscritorio * this.tutelaProvisoria.PercentualEncaminhadoPor * 0.01;
  }

  searchCallback = (search: string, item: INgxSelectOption) => {
    if (search.trim() === '') {
      return true;
    } else {
      return item.text && item.text.toLowerCase().includes(search.toLowerCase());
    }
  }

  removerAdvogado(index: number) {
    this.tutelaProvisoria.Advogados.splice(index, 1);
  }

  adicionarAdvogado() {
    const adv = new TutelaProvisoriaAdvogado();
    adv.AdvogadoId = 0;
    this.tutelaProvisoria.Advogados.push(adv);
  }

}
